module.exports = __webpack_public_path__ + "static/media/214.52fda7c9.png";